import {AfterViewInit, ChangeDetectionStrategy, Component, computed, inject, PLATFORM_ID} from '@angular/core';
import {RouterModule} from '@angular/router';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {RouterContextDirective} from '@core/directives/router-context.directive';
import {CommentsIconComponent} from '@core/svg-icons/comments-icon.component';
import {StoreConfigService} from '@core/services/store-config.service';
import {isPlatformBrowser, DecimalPipe} from '@angular/common';
import {environment} from '@env/environment';
import {CountrySelectorComponent} from '../../../../atoms/country-selector/country-selector.component';

@Component({
  selector: 'app-header-top',
  templateUrl: './header-top.component.html',
  styleUrls: ['./header-top.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, FontAwesomeModule, RouterContextDirective, CommentsIconComponent, DecimalPipe, CountrySelectorComponent]
})
export class HeaderTopComponent implements AfterViewInit {
  showOnDk = environment.locale === 'da-DK';
  showTrustpilot = environment.trustpilot?.enabled ?? false;
  showB2B = environment.supervin.showB2B;
  private storeConfigService = inject(StoreConfigService);
  private readonly platformId = inject(PLATFORM_ID);

  // Trustpilot widget configuration from environment
  readonly widgetConfig = environment.trustpilot?.widgets.horizontal ?? {};
  readonly locale = environment.trustpilot?.locale ?? 'da-DK';
  readonly businessunitId = environment.trustpilot?.businessunitId ?? '';
  readonly reviewPageUrl = environment.trustpilot?.reviewPageUrl ?? '';

  // Trygg e-handel configuration from environment
  readonly tryggEhandelGuid = (environment.tryggEhandel?.guid ?? '').trim();
  readonly showTryggEhandel = (environment.tryggEhandel?.enabled ?? false) && this.tryggEhandelGuid.length > 0;

  freeDeliveryStartsFrom = computed(() => {
    return this.storeConfigService.storeConfig()?.freeDeliveryStartsFrom;
  });

  minimumFreightPrice = computed(() => {
    return this.storeConfigService.storeConfig()?.minimumFreightPrice;
  });

  ngAfterViewInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      if (this.showTrustpilot) {
        this.loadTrustpilotWidget();
      }
      if (this.showTryggEhandel) {
        this.loadTryggEhandelScript();
      }
    }
  }

  private loadTryggEhandelScript(): void {
    if (!document.getElementById('trygg-ehandel-script')) {
      const script = document.createElement('script');
      script.id = 'trygg-ehandel-script';
      script.src = `https://cert.tryggehandel.net/js/script.js?id=${encodeURIComponent(this.tryggEhandelGuid)}`;
      script.async = true;
      document.head.appendChild(script);
    }
  }

  private loadTrustpilotWidget(): void {
    // Load Trustpilot script if not already loaded
    if (!document.getElementById('trustpilot-widget-script')) {
      const script = document.createElement('script');
      script.id = 'trustpilot-widget-script';
      script.src = 'https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
      script.async = true;
      document.head.appendChild(script);
      
      script.onload = () => {
        this.refreshWidget();
      };
    } else {
      // Script already loaded, just refresh the widget
      this.refreshWidget();
    }
  }

  private refreshWidget(): void {
    setTimeout(() => {
      const trustpilot = (window as any).Trustpilot;
      if (trustpilot && trustpilot.loadFromElement) {
        const trustboxElement = document.querySelector('.header-top__trustpilot .trustpilot-widget');
        if (trustboxElement) {
          trustpilot.loadFromElement(trustboxElement, true);
        }
      }
    }, 100);
  }

}
